<div class="p-fluid grid formgrid">
  <div class="field col-12 md:col-6">
    <label for="r015_year">Ano de produção</label>
    <input id="r015_year" type="number" pInputText [(ngModel)]="filters.year" />
  </div>
  <div class="field col-12 md:col-6">
    <label for="r015_actionComunication">Ação de comunicão</label>
    <p-skeleton
      height="2.5rem"
      styleClass="mb-2"
      *ngIf="isLoadingComboOptions"
    ></p-skeleton>
    <p-dropdown
      id="r015_actionComunication"
      [options]="comboOptions.comunication"
      [(ngModel)]="filters.comunication"
      placeholder="Todos"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      filterBy="label"
      [showClear]="true"
      *ngIf="!isLoadingComboOptions"
    ></p-dropdown>
  </div>
</div>
